import React, { Component, Fragment } from 'react';
import { scrollTo } from '../../../_helpers.js';
import './GifBrowserStrip.scss';

class GifBrowserStrip extends Component { 
    constructor(props) {
        super(props);   
        this.state = {
            category : props.category
        }    
    }
    componentDidMount () {
        // ready
        this.handleImgLoaded();
        this.handleScroll('left');
    }
    generateThumbnail = (el) => {     
        //generate thumbnail URL data
        const _img = el,
            _w = _img.width/1.5,
            _h = _img.height/1.5;
        
        const _canvas = document.createElement('canvas');
            _canvas.width = _w;
            _canvas.height = _h;
        
        const _context = _canvas.getContext('2d');
            _context.drawImage(_img, 0, 0, _w, _h);
        
        const _dataURL = _canvas.toDataURL();
    
        //create img
        let img = document.createElement('img');
        img.setAttribute('src', _dataURL);
        img.setAttribute('class', 'GifBrowser--thumbnail');
    
        //append img in container div
        _img.parentNode.appendChild(img);
    }
    handleScroll = (dir) => {
        let _target = this.refs[this.state.category.row],
            _inc = _target.querySelector('li'),
            _right = document.querySelector('li.GifBrowserStrip--controls--right'),
            _left = document.querySelector('li.GifBrowserStrip--controls--left'),
            _viewportWidth = window.innerWidth,
            _distance = (dir != 'left') ?  (_target.scrollLeft) + (_viewportWidth) : (_target.scrollLeft) - (_viewportWidth);
        
        scrollTo(_target, _distance, 500);
        
        //target.scrollLeft = _target.scrollLeft + _inc.offsetWidth;
    }
    handleImgLoaded = () => {
        let _allImg = this.refs[`row`].querySelectorAll('[data-thumbnail]'),
            _totalLoaded = 0;
        
        _allImg.forEach(img => {
            img.addEventListener('load', function(event) {
                _totalLoaded++;
                this.generateThumbnail(img);
                if (_totalLoaded == _allImg.length) {
                    this.props.callback(this.state.category.row);
                }
            }.bind(this));
        });
    }
    render () {
        let category = this.state.category;
        return (
            <div class="GifBrowserStrip">
                <section ref={ `row` } id={ `row-${category.row}` } class="strip">
                    <div>
                        <h3><span>🔥</span>{ category.label }</h3>
                    </div>
                    <div ref={ `${category.row}` } class="strip--wrapper">
                        <ul>
                            {category.gifs.map( gif =>
                                <li
                                    onClick={ () => this.props.handleClick(`#/${category.row}/${gif}`)}
                                    class={ `${category.row}-${gif}` === `${this.props.activeRow}-${this.props.activeGif}` ? "on" : "off"}
                                    ref={ `${category.row}-${gif}` }>
                                    <img data-thumbnail src={ `/assets/img/gifs/${gif}.gif` } alt={ `${gif}` } />
                                </li>
                            )}
                        </ul>
                    </div>
                    <ul class="GifBrowserStrip--controls">
                        <li onClick={ () => this.handleScroll('left') } class="GifBrowserStrip--controls--left"></li>
                        <li onClick={ () => this.handleScroll('right') } class="GifBrowserStrip--controls--right"></li>
                    </ul>
                </section>
            </div>
        );
    }
}

export default GifBrowserStrip;